import timeTrackingService from '@/services/timeTracking.service';


export const actions = {
  getLastClockIn({ commit }, { clinicId }) {
    return timeTrackingService.lastClockIn({ clinicId })
      .then(response => response.data)
      .catch((error) => {
        throw error;
      });
  },
  clockIn({ commit }, payload) {
    return timeTrackingService
      .clockIn(payload)
      .then(response => response.data)
      .catch((error) => {
        throw error;
      });
  },
  clockOut({ commit }, payload) {
    return timeTrackingService
      .clockOut(payload)
      .then(response => response.data)
      .catch((error) => {
        throw error;
      });
  },
};

export default {
  namespaced: true,
  actions,
};
